import React, { useContext, useEffect, useRef, useState } from "react";
import {
  FiAlignLeft,
  FiArrowLeft,
  FiArrowRight,
  FiChevronRight,
  FiMaximize,
  FiMinimize,
  FiMoon,
  FiPlus,
  FiSun,
} from "react-icons/fi";
import LanguagesModal from "./LanguagesModal";
import NotificationsModal from "./NotificationsModal";
import ProfileModal from "./ProfileModal";
import axios from "axios";
//import SearchModal from './SearchModal';
import TimesheetsModal from "./TimesheetsModal";
import HeaderDropDownModal from "./HeaderDropDownModal";
import MegaMenu from "./megaManu/MegaMenu";
import { NavigationContext } from "../../../contentApi/navigationProvider";
import useTranslations from "../../../hooks/useTranslations";
import useUserLanguage from "../../../hooks/useUserLanguage";

const BASE_URL = process.env.REACT_APP_API_BASE_URL;
const Header = () => {
  const { navigationOpen, setNavigationOpen } = useContext(NavigationContext);
  const [openMegaMenu, setOpenMegaMenu] = useState(false);
  const [navigationExpend, setNavigationExpend] = useState(false);
  const miniButtonRef = useRef(null);
  const expendButtonRef = useRef(null);
  // Çeviri için gerekli hook'lar
  const language = useUserLanguage();
  const { translations } = useTranslations(language);
  const getText = (key, defaultValue) => translations[key] || defaultValue;
  const [siteDomain, setSiteDomain] = useState("");
  const [languages, setLanguages] = useState([]);

  // → Yeni: mount olduğunda API’den site_domain çek
  useEffect(() => {
    (async () => {
      try {
        const { data } = await axios.get(`${BASE_URL}/api/settings/1`);
        setSiteDomain(data.site_domain);
      } catch (err) {
        console.error("Site domain alınamadı:", err);
      }
    })();
  }, []);
  useEffect(() => {
    const fetchLanguages = async () => {
      try {
        const res = await axios.get(`${BASE_URL}/api/languages/list/active`);
        setLanguages(res.data);
      } catch (err) {
        console.error("Diller alınamadı:", err);
      }
    };

    fetchLanguages();
  }, []);
  // Header.js içindeki mevcut changeLang fonksiyonunu bununla değiştir
  const changeLang = (lang) => {
    // 1. Dili tarayıcı hafızasına kaydet
    localStorage.setItem("admin_lang", lang);

    // 2. Sayfayı yeni dille yenile (URL'deki lang parametresini de korur)
    const url = new URL(window.location.href);
    url.searchParams.set("lang", lang);
    window.location.href = url.toString();
  };

  // getCurrentLang fonksiyonunu da hafızayı kontrol edecek şekilde güncelle
  const getCurrentLang = () => {
    return (
      new URLSearchParams(window.location.search).get("lang") ||
      localStorage.getItem("admin_lang") ||
      "tr"
    );
  };

  useEffect(() => {
    if (openMegaMenu) {
      document.documentElement.classList.add("nxl-lavel-mega-menu-open");
    } else {
      document.documentElement.classList.remove("nxl-lavel-mega-menu-open");
    }
  }, [openMegaMenu]);

  const handleThemeMode = (type) => {
    if (type === "dark") {
      document.documentElement.classList.add("app-skin-dark");
      localStorage.setItem("skinTheme", "dark");
    } else {
      document.documentElement.classList.remove("app-skin-dark");
      localStorage.setItem("skinTheme", "light");
    }
  };

  useEffect(() => {
    const handleResize = () => {
      const newWindowWidth = window.innerWidth;
      const upElement = document.querySelector(".navigation-up-1600");
      const downElement = document.querySelector(".navigation-down-1600");

      if (newWindowWidth <= 1024) {
        document.documentElement.classList.remove("minimenu");
        if (downElement) downElement.style.display = "none";
      } else if (newWindowWidth >= 1025 && newWindowWidth <= 1400) {
        document.documentElement.classList.add("minimenu");
        if (upElement) upElement.style.display = "none";
        if (downElement) downElement.style.display = "block";
      } else {
        document.documentElement.classList.remove("minimenu");
        if (upElement) upElement.style.display = "block";
        if (downElement) downElement.style.display = "none";
      }
    };

    window.addEventListener("resize", handleResize);

    handleResize();

    const savedSkinTheme = localStorage.getItem("skinTheme");
    handleThemeMode(savedSkinTheme);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const handleNavigationExpendUp = (e, pram) => {
    e.preventDefault();
    if (pram === "show") {
      setNavigationExpend(true);
      document.documentElement.classList.add("minimenu");
    } else {
      setNavigationExpend(false);
      document.documentElement.classList.remove("minimenu");
    }
  };

  const handleNavigationExpendDown = (e, pram) => {
    e.preventDefault();
    if (pram === "show") {
      setNavigationExpend(true);
      document.documentElement.classList.remove("minimenu");
    } else {
      setNavigationExpend(false);
      document.documentElement.classList.add("minimenu");
    }
  };

  const fullScreenMaximize = () => {
    const elem = document.documentElement;

    if (elem.requestFullscreen) {
      elem.requestFullscreen();
    } else if (elem.mozRequestFullScreen) {
      elem.mozRequestFullScreen();
    } else if (elem.webkitRequestFullscreen) {
      elem.webkitRequestFullscreen();
    } else if (elem.msRequestFullscreen) {
      elem.msRequestFullscreen();
    }

    document.documentElement.classList.add("fsh-infullscreen");
    document.querySelector("body").classList.add("full-screen-helper");
  };
  const fullScreenMinimize = () => {
    if (document.exitFullscreen) {
      document.exitFullscreen();
    } else if (document.mozCancelFullScreen) {
      document.mozCancelFullScreen();
    } else if (document.webkitExitFullscreen) {
      document.webkitExitFullscreen();
    } else if (document.msExitFullscreen) {
      document.msExitFullscreen();
    }

    document.documentElement.classList.remove("fsh-infullscreen");
    document.querySelector("body").classList.remove("full-screen-helper");
  };

  return (
    <header className="nxl-header">
      <div className="header-wrapper">
        {/* <!--! [Start] Header Left !--> */}
        <div className="header-left d-flex align-items-center gap-4">
          {/* <!--! [Start] nxl-head-mobile-toggler !--> */}
          <a
            href="#"
            className="nxl-head-mobile-toggler"
            onClick={(e) => {
              e.preventDefault();
              setNavigationOpen(true);
            }}
            id="mobile-collapse"
          >
            <div
              className={`hamburger hamburger--arrowturn ${
                navigationOpen ? "is-active" : ""
              }`}
            >
              <div className="hamburger-box">
                <div className="hamburger-inner"></div>
              </div>
            </div>
          </a>
          {/* <!--! [Start] nxl-head-mobile-toggler !-->
                    <!--! [Start] nxl-navigation-toggle !--> */}

          {/* <!--! [End] nxl-navigation-toggle !-->
                    <!--! [Start] nxl-lavel-mega-menu-toggle !--> */}
        </div>
        {/* <!--! [End] Header Left !-->
                <!--! [Start] Header Right !--> */}

        <div className="header-right ms-auto">
          <div className="d-flex align-items-center">
         
            {/* ← “Site’ye Git” butonu */}
            {siteDomain && (
              <div className="nxl-h-item">
                <a
                  href={siteDomain}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="nxl-head-link me-2"
                  title={getText("GO_TO_SITE")}
                >
                  <FiArrowRight size={20} />
                </a>
              </div>
            )}

            <div className="nxl-h-item d-none d-sm-flex">
              <div className="full-screen-switcher">
                <span
                  className="nxl-head-link me-0"
                  title={getText("FULL_SCREEN")}
                >
                  <FiMaximize
                    size={20}
                    className="maximize"
                    onClick={fullScreenMaximize}
                  />
                  <FiMinimize
                    size={20}
                    className="minimize"
                    onClick={fullScreenMinimize}
                  />
                </span>
              </div>
            </div>

            <div className="nxl-h-item dark-light-theme">
              <div
                className="nxl-head-link me-0 dark-button"
                onClick={() => handleThemeMode("dark")}
                title={getText("DARK_MODE")}
              >
                <FiMoon size={20} />
              </div>
              <div
                className="nxl-head-link me-0 light-button"
                onClick={() => handleThemeMode("light")}
                style={{ display: "none" }}
                title={getText("LIGHT_MODE")}
              >
                <FiSun size={20} />
              </div>
            </div>

            <ProfileModal />
          </div>
        </div>
        {/* <!--! [End] Header Right !--> */}
      </div>
    </header>
  );
};

export default Header;
